module.exports = __webpack_public_path__ + "img/documentos-menu.512c1620.svg";